import script from "./PPrivacy.vue?vue&type=script&setup=true&lang=js"
export * from "./PPrivacy.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__